import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h8.656l-1.5 1.5H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-7.219l1.5-1.5v8.72q0 .756-.525 1.282-.525.525-1.283.525zM9.5 13.596v-1.78q0-.362.14-.696t.387-.58l8.533-8.532a1.5 1.5 0 0 1 .511-.34q.279-.106.567-.106.295 0 .566.106.27.107.494.33l1.256 1.252q.218.233.333.513.117.281.117.57 0 .287-.1.56-.098.27-.331.503l-8.561 8.562a1.9 1.9 0 0 1-.58.394 1.7 1.7 0 0 1-.696.148h-1.732a.88.88 0 0 1-.645-.259.88.88 0 0 1-.259-.645M11 13h1.246l6.233-6.233-.623-.623-.668-.642L11 11.69z"
    }, null, -1)
  ])))
}
export default { render: render }